<template>
    <b-modal
        id="rubric-add-survey"
        :title="$t('rubrics.new_invitation')"
        size="lg"
        @ok="onOk"
        @show="onShow"
        hide-footer
        modal-class="apprentice-default-modal add-rubric-survey-modal"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        :ok-title="$t('rubrics.sent')">
        <div class="add-survey">
            <div class="description">
                {{ $t('rubrics.invite_students_to_complete_a_rubric_for_a_specific_skill') }}
            </div>

            <design-2021-simple-multi-steps-form-component
                ref="multiStepForm"
                :steps="steps"
                @validate-step="validateStep"
                @submit-form="onOk">
                <template #step1>
                    <div
                        class="errors"
                        v-if="emptySurveyNameError">
                        <b-alert
                            show
                            variant="danger">
                            {{ $t('rubrics.invitation_name_cannot_be_empty') }}
                        </b-alert>
                    </div>

                    <b-form-group
                        class="survey-name-group"
                        :label="$t('common.name')"
                        label-for="survey-name-input">
                        <template v-slot:label> {{ $t('common.name') }} <span class="required">*</span></template>
                        <b-form-input
                            id="survey-name-input"
                            v-model="surveyName"
                            required
                            :placeholder="$t('rubrics.fill_a_name_in_for_this_survey')">
                        </b-form-input>
                    </b-form-group>
                </template>

                <template #step2>
                    <div
                        class="errors"
                        v-if="emptyRubricError">
                        <b-alert
                            show
                            variant="danger">
                            {{ $t('rubrics.no_rubrics_found') }}
                        </b-alert>
                    </div>
                    <design-2021-rubric-survey-add-skills-and-students-component
                        v-model="rubricData"
                        :skill-trees-in="skillTrees"
                        :is-project="isProjects"
                        :las-groups-in="allLasGroups"
                        :las-main-groups-in="allLasMainGroups"
                        :project-options-in="projectOptions">
                    </design-2021-rubric-survey-add-skills-and-students-component>
                </template>

                <template #step3>
                    <div class="rubric-survey-settings">
                        <div class="survey-rating-option">
                            <h4 class="title">{{ $t('rubrics.peer_feedback') }}</h4>

                            <b-form-group
                                class="survey-rating-option-group"
                                :label="$t('rubrics.assessment_type')">
                                <b-form-select
                                    class="apprentice-primary-select"
                                    id="survey-rating-option"
                                    v-model="peer_option"
                                    :options="peer_options">
                                </b-form-select>
                            </b-form-group>

                            <b-form-group
                                class="max-peer-rating-option-group"
                                v-if="peer_option !== null"
                                :label="$t('rubrics.number_of_fellow_students')"
                                label-for="max-peer-rating-option-input">
                                <b-form-input
                                    class="apprentice-primary-input"
                                    id="max-peer-rating-option-input"
                                    v-model="peer_amount"
                                    type="number"></b-form-input>
                            </b-form-group>
                        </div>

                        <div class="survey-choose-teacher">
                            <h4 class="title">{{ $t('rubrics.choose_teachers') }}</h4>

                            <b-form-group
                                class="survey-choose-teacher-group"
                                :label="$t('rubrics.select_teachers_here')">
                                <design-2021-apprentice-multiselect-component
                                    id="survey-choose-teacher-selects"
                                    v-model="selectedTeachers"
                                    label="full_name"
                                    :allow-empty="true"
                                    :options="teachers"
                                    track-by="id">
                                </design-2021-apprentice-multiselect-component>
                            </b-form-group>
                        </div>
                    </div>
                </template>
            </design-2021-simple-multi-steps-form-component>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-rubric-survey-add-survey-modal',
    data() {
        return {
            steps: [
                { step_no: 1, step_valid: false, step_skip: false },
                { step_no: 2, step_valid: false, step_skip: false },
                { step_no: 3, step_valid: false, step_skip: true },
            ],
            surveyName: '',
            skillTrees: [],
            projectOptions: [],
            peer_option: null,
            peer_options: [
                { text: this.$t('rubrics.students_do_not_assess_each_other'), value: null },
                { text: this.$t('rubrics.student_chooses_fellow_students_himself'), value: 1 },
                { text: this.$t('rubrics.the_system_automatically_chooses_fellow_students'), value: 2 },
            ],
            peer_amount: 1,
            loaded: false,
            isProjects: false,
            allLasMainGroups: [],
            allLasGroups: [],
            teachers: [],
            selectedTeachers: [],
            error: false,
            emptyRubricError: false,
            emptySurveyNameError: false,
            rubricData: {
                lasMainGroups: [],
                lasGroups: [],
                projects: [],
                rubrics: [],
            },
            rubricFields: [
                {
                    key: 'rubric',
                    label: this.$t('rubrics.rubric'),
                },
                {
                    key: 'skill',
                    label: this.$t('rubrics.skill'),
                },
                {
                    key: 'skillTree',
                    label: this.$t('rubrics.set'),
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },

    methods: {
        validateStep(stepIndex) {
            switch (stepIndex) {
                case 0:
                    this.validateFirstStep(stepIndex);
                    break;
                case 1:
                    this.validateSecondStep(stepIndex);
                    break;

                default:
                    this.validatedStep(stepIndex);
            }
        },

        validateFirstStep(stepIndex) {
            this.emptySurveyNameError = false;
            if (this.surveyName === '') {
                this.emptySurveyNameError = true;
                return;
            }

            this.validatedStep(stepIndex);
        },

        validateSecondStep(stepIndex) {
            this.emptyRubricError = false;
            if (this.rubricData.rubrics.length === 0) {
                this.emptyRubricError = true;
                $('.add-rubric-survey-modal').animate({ scrollTop: 0 }, 500);
                return;
            }

            this.validatedStep(stepIndex);
        },

        validatedStep(stepIndex) {
            this.steps[stepIndex].step_valid = true;
            this.$refs.multiStepForm.nextStep();
        },

        onOk(bvModalEvt) {
            if (!this.rubricData) {
                this.error = true;
                bvModalEvt.preventDefault();
                return;
            }

            let rubricIds = this.rubricData.rubrics.map((rubric) => rubric.rubricId);

            let projectIds = this.rubricData.projects.map((project) => project.id);

            let lasGroupIds = this.rubricData.lasGroups.map((lasGroup) => lasGroup.id);

            let lasMainGroupIds = this.rubricData.lasMainGroups.map((lasMainGroup) => lasMainGroup.id);

            let teacherIds = this.selectedTeachers.map((teacher) => teacher.id);

            let data = {
                survey_name: this.surveyName,
                peer_option: this.peer_option,
                peer_amount: this.peer_option ? this.peer_amount : null,
                rubric_ids: rubricIds,
                las_group_ids: lasGroupIds,
                las_main_group_ids: lasMainGroupIds,
                project_ids: projectIds,
                teacher_ids: teacherIds,
            };

            this.$emit('addRubricSurvey', data);
            this.$bvModal.hide('rubric-add-survey');
        },

        onShow() {
            this.skillTrees = [];
            this.skill = [];
            this.loaded = false;
            this.peer_option = null;
            this.peer_amount = 1;
            this.projectOptions = [];
            this.isProjects = false;
            this.allLasGroups = [];
            this.allLasMainGroups = [];
            this.error = false;
            this.surveyName = '';
            this.rubricData.lasMainGroups = [];
            this.rubricData.lasGroups = [];
            this.rubricData.projects = [];
            this.rubricData.rubrics = [];

            if (this.loaded === false) {
                this.axios.get(this.routes.getRubricSurvey()).then(
                    (response) => {
                        this.skillTrees = response.data.skillTrees;
                        this.projectOptions = response.data.projects;
                        this.allLasGroups = response.data.lasLocation ? response.data.lasLocation.groups : null;
                        this.allLasMainGroups = response.data.lasLocation
                            ? response.data.lasLocation.main_groups
                            : null;
                        this.teachers = response.data.teachers;

                        this.loaded = true;
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            }
        },
    },
};
</script>

<style scoped lang="scss">
select,
select,
fieldset {
    margin-bottom: 0;
}

.description {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    color: $text-muted-color;
    font-weight: $font-weight-bold;
}

.rubric-survey-settings {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    row-gap: $grid-gutter-width;
}

.max-peer-rating-option-group {
    margin-top: map-get($grid-gutter-spacing, 'fifteen');
}

@media (min-width: map-get($grid-breakpoints, 'md')) {
    .rubric-survey-settings {
        flex-direction: row;
        row-gap: 0;
        column-gap: $grid-gutter-width;
    }

    .survey-rating-option,
    .survey-choose-teacher {
        display: flex;
        flex-direction: column;
        flex: 0 1 calc(50% - 15px);

        .form-group {
            margin-bottom: 0;
        }
    }

    .survey-choose-teacher {
        .form-group {
            margin-top: 22px;
        }
    }
}
</style>
